<ion-content class="container">
  
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickSetup()">
        <label class="font_semibold fs-16 ml-10 mt-5 black_color">
          <span class="cp" (click)="onClickSetup()">Increment</span> / <span
            [style.color]="buttonColorName">Logs</span></label>
      </div>
    </ion-col> 
  </ion-row>

  <ion-row class="line-wrapper">
  <!-- Left side -->
  <ion-col size="12" size-md="9" class="left-section">
    <div class="left-items">
      <!-- Year -->
      <div class="item-block">
        <p class="fs-14 mb-10">Year</p>
        <mat-form-field class="w-150 mat-height40 mat-input-style">
          <mat-select placeholder="Select Year"
                      [(ngModel)]="selectedYear"
                      (selectionChange)="onYearChange($event)">
            <mat-option [value]="item.year" *ngFor="let item of getIncrementFyYearList">
              {{ sharedService.transformYearToFyFormat(item.year) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Change Type -->
      <div class="item-block ml-40">
        <p class="fs-14 mb-10">Change Type</p>

        <mat-form-field class="w-150 mat-height40 mat-input-style">
          <mat-select placeholder="Select"
                      name="changeType"
                      [(ngModel)]="selectChangeType"
                      (selectionChange)="onSelectChangeType($event.value)">
            <mat-option value="All">All</mat-option>
            <mat-option value="Setup">Setup</mat-option>
            <mat-option value="Increment Input">Increment Input</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </ion-col>

  <!-- Right side -->
  <ion-col size="12" size-md="3" class="right-section ion-text-right">
    <span class="fs-20 material-icons btn-reset mr-10"
          style="cursor:pointer;"
          (click)="resetGrid()">
      refresh
    </span>

    <span class="fs-20 material-icons icon-download"
          style="cursor:pointer;"
          (click)="onBtExport()">
      download
    </span>
  </ion-col>
</ion-row>


  <div class="table-layout">
    <ion-grid class="p-0">
      <div class="tableBox mt-10">
        <ion-row class="p-0">
          <!-- <table class="hover">
            <thead class="bg-gray">
              <tr>
                <th class="fs-14 font_bold cl-black" *ngFor="let item of gridData.columnInfo">
                  <div class="verticle-center icon-style">{{item.label}}
                    <div class="d-flex flex-column ml-10" *ngIf="item.label != 'Action'">
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                        (click)="sortAsending(item.sortingName)">arrow_drop_up</i>
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                        (click)="sortDesending(item.sortingName)">arrow_drop_down</i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
      
            <tbody class="bg-white" *ngIf="renderData.length !== 0">
              <tr *ngFor="let item of renderData;let i=index">
                <ng-container *ngFor="let innerItem of item">
                  <td *ngIf="innerItem.key !== 'id'" class="fs-16 font_regular">
                    <span>{{innerItem.value}}</span>
                    <a *ngIf="innerItem.value == 'uploadingTheContract' &&
                    (innerItem.key== 'oldValue' || innerItem.key == 'newValue')" [href]="innerItem.value" target="_blank">Contract</a>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table> -->
        <mat-sidenav-container style="height: 100%; width: 100%;">
          <!-- Main Content with AG Grid -->
           
          <mat-sidenav-content>
            <ag-grid-angular
              style="width: 100%; height: 600px;"
              class="ag-theme-quartz"
              [rowData]="gridData.columnData"
              [columnDefs]="columnDefs"
              [gridOptions]="gridOptions"
              [defaultColDef]="defaultColDef"
              (gridReady)="onGridReady($event)"
              (rowClicked)="onRowClicked($event)"
              [pagination]="pagination"
              [paginationPageSize]="paginationPageSize"
              [paginationPageSizeSelector]="paginationPageSizeSelector"
              [detailRowAutoHeight]="detailRowAutoHeight"
              [localeText]="{ noRowsToShow: 'No Data Found' }"
            >
            </ag-grid-angular>
          </mat-sidenav-content>
        </mat-sidenav-container>
        
        
        </ion-row>
      </div>
   
      <!-- <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="display-end">
        <ul class="dt_pagination">
          <ion-row class="float-right pgintn">
            <li class="fs-16">{{currentPage}}</li>
            <span class="fs-14 font_regular p-10">of {{gridData.totalNoOfPages}}</span>
            <li class="fs-24 cp" (click)="previousPage()" [ngClass]="{'disableBtn': currentPage==1}">&lt;</li>
            <li class="fs-24 cp" (click)="nextPage()" [ngClass]="{'disableBtn': currentPage== gridData.totalNoOfPages}">
              &gt;</li>
          </ion-row>
        </ul>
      </ion-col>
      <div class="clear100"></div>
      <div class="clear20"></div> -->
    </ion-grid>
  </div>
</ion-content>


